export default {"src":"/_next/static/media/ic-arrow-login.3f1302cc.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};